/**
 *
 */
export enum ClimateGraphType {
    T2M = "T2m",
    RH = "RH"
}